import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/Card';
import { Badge } from '../components/Badge';
import { Button } from '../components/Button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/Table';
import { Shield, Plus, Edit2, Trash2, XCircle, User, Clock, Activity, Key, Smartphone, Lock, Unlock } from 'lucide-react';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../data/store';
import { StatusBadge } from '../components/StatusBadge';
import { FilterBar, FilterField } from '../components/FilterBar';
import { Filter } from 'lucide-react';
import { SyncButton } from '../components/SyncButton';
export default function Users() {
  const navigate = useNavigate();
  const users = useStore(s => s.users);
  const toggleUserStatus = useStore(s => s.toggleUserStatus);
  const resetPassword = useStore(s => s.resetPassword);
  const resetMFA = useStore(s => s.resetMFA);
  const resetDevice = useStore(s => s.resetDevice);
  const [showFilters, setShowFilters] = useState(false);
  const [filterValues, setFilterValues] = useState<Record<string, any>>({});
  const handleFilterChange = (key: string, value: any) => {
    setFilterValues(prev => ({
      ...prev,
      [key]: value
    }));
  };
  const handleResetFilters = () => {
    setFilterValues({});
  };
  const filteredUsers = users.filter(u => {
    const search = filterValues.search?.toLowerCase() || '';
    const matchesSearch = !search || u.name?.toLowerCase().includes(search) || u.id.toLowerCase().includes(search) || u.username.toLowerCase().includes(search);
    const matchesRole = !filterValues.role || filterValues.role === 'all' || u.role === filterValues.role;
    const matchesRegion = !filterValues.region || filterValues.region === 'all' || u.region === filterValues.region;
    const matchesStatus = !filterValues.status || filterValues.status === 'all' || u.status === filterValues.status;
    return matchesSearch && matchesRole && matchesRegion && matchesStatus;
  });
  const filterFields: FilterField[] = [{
    key: 'search',
    label: 'Pencarian',
    type: 'search',
    placeholder: 'Cari nama, ID, username...'
  }, {
    key: 'role',
    label: 'Peran',
    type: 'select',
    options: [{
      label: 'Super Admin Nasional',
      value: 'Super Admin Nasional'
    }, {
      label: 'Administrator Nasional',
      value: 'Administrator Nasional'
    }, {
      label: 'Kepala BINDA',
      value: 'Kepala BINDA'
    }, {
      label: 'Wakil Kepala BINDA',
      value: 'Wakil Kepala BINDA'
    }, {
      label: 'Admin BINDA',
      value: 'Admin BINDA'
    }, {
      label: 'Analis',
      value: 'Analis'
    }, {
      label: 'Koordinator Wilayah',
      value: 'Koordinator Wilayah'
    }, {
      label: 'Operator Command Center',
      value: 'Operator Command Center'
    }, {
      label: 'Personel Lapangan',
      value: 'Personel Lapangan'
    }]
  }, {
    key: 'region',
    label: 'Wilayah',
    type: 'select',
    options: [{
      label: 'Nasional',
      value: 'Nasional'
    }, {
      label: 'DKI Jakarta',
      value: 'DKI Jakarta'
    }, {
      label: 'Jawa Barat',
      value: 'Jawa Barat'
    }, {
      label: 'Sumatera Utara',
      value: 'Sumatera Utara'
    }, {
      label: 'Riau',
      value: 'Riau'
    }]
  }, {
    key: 'status',
    label: 'Status Akun',
    type: 'statusBadge',
    options: [{
      label: 'Aktif',
      value: 'Aktif'
    }, {
      label: 'Tidak Aktif',
      value: 'Tidak Aktif'
    }]
  }];
  const exportColumns = [{
    key: 'id',
    label: 'ID'
  }, {
    key: 'name',
    label: 'Nama Lengkap'
  }, {
    key: 'username',
    label: 'Username'
  }, {
    key: 'role',
    label: 'Peran'
  }, {
    key: 'region',
    label: 'Wilayah'
  }, {
    key: 'unit',
    label: 'Unit'
  }, {
    key: 'status',
    label: 'Status'
  }];
  const handleToggleStatus = (id: string, currentStatus: string) => {
    toggleUserStatus(id);
    toast.success(`Status pengguna ${id} diperbarui.`);
  };
  const handleResetPasswordAction = (id: string) => {
    resetPassword(id);
    toast.success(`Tautan reset kata sandi dikirim ke pengguna ${id}.`);
  };
  const handleResetMFAAction = (id: string) => {
    resetMFA(id);
    toast.success(`MFA untuk pengguna ${id} telah direset.`);
  };
  const handleResetDeviceAction = (id: string) => {
    resetDevice(id);
    toast.success(`Perangkat untuk pengguna ${id} telah dilepas tautannya.`);
  };
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-4139">
      <div className="flex justify-between items-end border-b border-border/50 pb-4" data-id="element-4140">
        <div data-id="element-4141">
          <h1 className="text-2xl font-heading font-bold tracking-tight text-foreground" data-id="element-4142">
            MANAJEMEN PENGGUNA
          </h1>
          <p className="text-muted-foreground font-mono text-xs mt-1 uppercase tracking-widest" data-id="element-4143">
            Kontrol Akses Sistem // Konsol Admin
          </p>
        </div>
        <div className="flex gap-3 items-center" data-id="element-4144">
          <Button variant={showFilters ? 'default' : 'outline'} size="sm" onClick={() => setShowFilters(!showFilters)} className={`h-8 border-border/50 font-mono text-xs ${showFilters ? 'bg-primary text-primary-foreground' : 'bg-background/50'}`} data-id="element-4145">
            <Filter className="w-4 h-4 mr-2" data-id="element-4146" />
            Filter
          </Button>
          <SyncButton data-id="element-4147" />
          <Button onClick={() => toast.success('Formulir tambah pengguna baru dibuka.')} className="bg-primary hover:bg-primary/90 text-primary-foreground font-mono text-xs tracking-widest uppercase shadow-[0_0_15px_rgba(var(--primary),0.3)]" data-id="element-4148">
            <Plus className="w-4 h-4 mr-2" data-id="element-4149" />
            Tambah Pengguna
          </Button>
        </div>
      </div>

      {showFilters && <FilterBar fields={filterFields} values={filterValues} onChange={handleFilterChange} onApply={() => {}} onReset={handleResetFilters} resultCount={filteredUsers.length} exportData={filteredUsers} exportColumns={exportColumns} exportFilename="Data_Pengguna_DENS_CAKRA" data-id="element-4150" />}

      <div className="grid grid-cols-1 gap-6" data-id="element-4151">
        <Card className={`glass-panel-heavy border-border/50 shadow-[0_0_20px_rgba(0,0,0,0.5)] transition-all duration-300`} data-id="element-4152">
          <CardHeader className="border-b border-border/50 bg-card/50" data-id="element-4153">
            <CardTitle className="text-sm font-mono uppercase tracking-widest flex items-center gap-2" data-id="element-4154">
              <Shield className="w-4 h-4 text-primary" data-id="element-4155" /> Pengguna Sistem
            </CardTitle>
          </CardHeader>
          <CardContent className="p-0" data-id="element-4156">
            <Table data-id="element-4157">
              <TableHeader className="bg-black/20" data-id="element-4158">
                <TableRow className="border-border/30 hover:bg-transparent" data-id="element-4159">
                  <TableHead className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground" data-id="element-4160">
                    ID
                  </TableHead>
                  <TableHead className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground" data-id="element-4161">
                    Nama Lengkap
                  </TableHead>
                  <TableHead className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground" data-id="element-4162">
                    Unit / Wilayah
                  </TableHead>
                  <TableHead className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground" data-id="element-4163">
                    Peran
                  </TableHead>
                  <TableHead className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground" data-id="element-4164">
                    Status
                  </TableHead>
                  <TableHead className="text-right text-[10px] font-mono uppercase tracking-widest text-muted-foreground" data-id="element-4165">
                    Aksi
                  </TableHead>
                </TableRow>
              </TableHeader>
              <TableBody data-id="element-4166">
                {filteredUsers.map(u => <TableRow key={u.id} className={`border-border/20 hover:bg-white/5 transition-colors cursor-pointer border-l-2 border-l-transparent`} onClick={() => navigate(`/users/${u.id}`)} data-id="element-4167">
                    <TableCell className="font-mono text-xs text-muted-foreground" data-id="element-4168">
                      {u.id}
                    </TableCell>
                    <TableCell className="font-medium text-sm" data-id="element-4169">
                      {u.name}
                      <div className="text-[10px] font-mono text-muted-foreground" data-id="element-4170">
                        {u.email}
                      </div>
                    </TableCell>
                    <TableCell className="text-xs" data-id="element-4171">
                      {u.unit}
                      <div className="text-[10px] font-mono text-muted-foreground" data-id="element-4172">
                        {u.region}
                      </div>
                    </TableCell>
                    <TableCell className="text-xs" data-id="element-4173">{u.role}</TableCell>
                    <TableCell data-id="element-4174">
                      <StatusBadge status={u.status === 'Aktif' ? 'Normal' : 'Kritis'} data-id="element-4175" />
                    </TableCell>
                    <TableCell className="text-right" data-id="element-4176">
                      <div className="flex justify-end gap-1" data-id="element-4177">
                        <Button variant="ghost" size="icon" className="h-7 w-7 hover:text-primary" title="Edit Pengguna" onClick={e => {
                      e.stopPropagation();
                      navigate(`/users/${u.id}`);
                    }} data-id="element-4178">
                          <Edit2 className="w-3 h-3" data-id="element-4179" />
                        </Button>
                        <Button variant="ghost" size="icon" className="h-7 w-7 hover:text-primary" title="Reset Kata Sandi" onClick={e => {
                      e.stopPropagation();
                      handleResetPasswordAction(u.id);
                    }} data-id="element-4180">
                          <Key className="w-3 h-3" data-id="element-4181" />
                        </Button>
                        <Button variant="ghost" size="icon" className="h-7 w-7 hover:text-primary" title="Reset MFA" onClick={e => {
                      e.stopPropagation();
                      handleResetMFAAction(u.id);
                    }} data-id="element-4182">
                          <Shield className="w-3 h-3" data-id="element-4183" />
                        </Button>
                        <Button variant="ghost" size="icon" className="h-7 w-7 hover:text-primary" title="Reset Perangkat" onClick={e => {
                      e.stopPropagation();
                      handleResetDeviceAction(u.id);
                    }} data-id="element-4184">
                          <Smartphone className="w-3 h-3" data-id="element-4185" />
                        </Button>
                        <Button variant="ghost" size="icon" className={`h-7 w-7 ${u.status === 'Aktif' ? 'hover:text-destructive' : 'hover:text-[var(--status-active)]'}`} title={u.status === 'Aktif' ? 'Nonaktifkan' : 'Aktifkan'} onClick={e => {
                      e.stopPropagation();
                      handleToggleStatus(u.id, u.status);
                    }} data-id="element-4186">
                          {u.status === 'Aktif' ? <Lock className="w-3 h-3" data-id="element-4187" /> : <Unlock className="w-3 h-3" data-id="element-4188" />}
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      </div>
    </div>;
}